import React, { useState, Fragment, useCallback } from 'react'
import { ThemeProvider } from 'styled-components'

import { KEY_VALUES } from '../../constants'
import { COLORS, THEME } from '../../styles'
import { useLocalization } from '../../contexts/L10nContext'
import Icon from '../Icon'

import Styled from './AvailabilityZoneSwitcher.styled'

const AvailabilityZoneSwitcher = ({ className, variant }) => {
  const { availableZones } = useLocalization()
  const availabilityZone =
    availableZones &&
    availableZones.find(
      (zone) => zone.id === process.env.NEXT_PUBLIC_AVAILABILITY_ZONE,
    )
  const [isOpen, setIsOpen] = useState(false)

  const changeAZ = useCallback(
    (az) => () => {
      if (az === process.env.NEXT_PUBLIC_AVAILABILITY_ZONE) return
      if (typeof window !== 'undefined') {
        let domain = 'https://jow.fr/'
        const zone = availableZones && availableZones.find((z) => z.id === az)
        if (zone) {
          domain = zone.websiteUrl
        }
        window.location.replace(domain)
      }
    },
    [availableZones],
  )

  return availabilityZone ? (
    <ThemeProvider theme={{ variant }}>
      <Styled className={className}>
        <Styled.tooltip
          role="button"
          tabIndex={0}
          onKeyPress={(event) => {
            if (event.key === KEY_VALUES.ENTER) {
              setIsOpen((o) => !o)
            }
          }}
          isOpen={isOpen}
          onClick={() => setIsOpen((o) => !o)}
          onMouseLeave={() => setIsOpen(false)}
          onMouseEnter={() => setIsOpen(true)}
        >
          <Styled.tooltipDiscoverable>
            <Icon
              name="map-16"
              fill={
                variant === 'page'
                  ? THEME.COLORS.foreground.primary
                  : COLORS.primary
              }
              width={16}
              height={16}
            />
            <Styled.tooltipDiscoverableLanguage>
              {availabilityZone.name}
            </Styled.tooltipDiscoverableLanguage>
            <Styled.tooltipDiscoverableDropdown
              name="direction-down-16"
              width={16}
              height={16}
              fill={COLORS.black}
              isOpen={isOpen}
            />
          </Styled.tooltipDiscoverable>
          <Styled.tootipContainer>
            <Styled.tooltipContent>
              {availableZones.map(({ id, name, flag }, index) => {
                const isChecked =
                  id === process.env.NEXT_PUBLIC_AVAILABILITY_ZONE
                return (
                  <Fragment key={id}>
                    <Styled.availabilityZone
                      role="button"
                      tabIndex={0}
                      onKeyPress={(event) => {
                        if (event.key === KEY_VALUES.ENTER) {
                          changeAZ(id)
                        }
                      }}
                      onClick={changeAZ(id)}
                      isChecked={isChecked}
                    >
                      <Styled.availabilityZoneFlag role="img" aria-label={name}>
                        {flag}
                      </Styled.availabilityZoneFlag>
                      <Styled.availabilityZoneName isChecked={isChecked}>
                        {name}
                      </Styled.availabilityZoneName>
                      <Styled.availabilityZoneCheck
                        name="checkmark-16"
                        fill={isChecked ? COLORS.primary : 'none'}
                        width={16}
                        height={16}
                      />
                    </Styled.availabilityZone>
                    {index < availableZones.length - 1 && <Styled.separator />}
                  </Fragment>
                )
              })}
            </Styled.tooltipContent>
          </Styled.tootipContainer>
        </Styled.tooltip>
      </Styled>
    </ThemeProvider>
  ) : null
}

AvailabilityZoneSwitcher.defaultProps = {
  variant: 'footer',
}

export default AvailabilityZoneSwitcher
